module.exports = __webpack_public_path__ + "static/media/2020-01-05 discord-to-do.e3c598f1.md";